import React from 'react';
import { IPageProps, useHeroSlider, usePage, useTranslate } from '@vfit/consumer/data-access';
import { Footer, Header } from '@vfit/shared/components';
import { useTrackingProvider, useHeader, useFooter, AppMobile } from '@vfit/shared/data-access';
import { HeroSliderConsumer, StickyBannerHeader } from '@vfit/consumer/components';
import { GlobalWrapper, MainContainer } from '../Layout/pageLayout.style';
import Widgets from '../../Widgets/widgets';
import TaggingHomepage from './homepage.tagging';
import BrightSky from '../../BrightSky/brightSky';

export default function Homepage({ page }: IPageProps) {
  const { pageNavigation } = usePage();
  const { elements, haveHeader, isHeaderSmall, haveFooter, isDisabledInitialTrack, isNewHeader } =
    page?.params || {};
  const { widgets, taggingOptions, stickybanner, topheaderbanner } = elements || {};
  const { header, tagging } = useHeader(pageNavigation);
  const { slides: topHomeSlide } = useHeroSlider(elements?.heroslider);
  const { isReady: isTaggingReady } = useTrackingProvider();
  const { translate } = useTranslate();

  const { footer } = useFooter(pageNavigation);

  return (
    <>
      {isTaggingReady && (
        <TaggingHomepage
          taggingOptions={taggingOptions}
          isDisabledInitialTrack={isDisabledInitialTrack}
        />
      )}
      <GlobalWrapper />
      <MainContainer id="mainContainer">
        {haveHeader && header && !AppMobile.checkIsApp() && (
          <Header
            disablePaddingTop
            onTrack={tagging}
            header={header}
            lite={isHeaderSmall}
            onTranslate={translate}
            isExtendedHeader={isNewHeader}
            topHeaderBanner={topheaderbanner}
          />
        )}
        <HeroSliderConsumer slides={topHomeSlide} />
        {stickybanner && <StickyBannerHeader bannerCustomConfig={stickybanner} />}
        {widgets?.sliders && <Widgets widgets={widgets?.sliders} tagging={tagging} />}
        {haveFooter && footer && !AppMobile.checkIsApp() && (
          <Footer onTrack={`${tagging}_FOOTER`} footer={footer} subChildren={<BrightSky />} />
        )}
      </MainContainer>
    </>
  );
}

